module.exports = __webpack_public_path__ + "img/30.373ced1f.jpg";